// ** Custom Components
import { CardWrapper } from "components/layout/Card/CardWrapper";
import MediaPost_useInView from "components/user/MediaPosts/MediaPost_useInView";

// #####################################################
export const GalleryListItemContent = ({ galleryItem }) => {
	const user = {
		login: galleryItem.login,
		user_id: galleryItem.user_id,
		avatar: galleryItem.avatar,
		online: galleryItem.online,
		private_data: galleryItem.private_data,
		profile_status: galleryItem.profile_status,
		status_vip: galleryItem.status_vip,
	};

	// #####################################################

	return (
		<CardWrapper key={galleryItem.id}>
			<MediaPost_useInView
				item={{
					...galleryItem,
					media_type: galleryItem.media_type,
				}}
				user={user}
				sizePost="large_post"
			/>
		</CardWrapper>
	);
};

// #####################################################
